import React from 'react';

import {AlwaysCollapsedTable} from 'notebook/tables/collapse/AlwaysCollapsedTable';

import {BasicTableProps} from '../StructuredTableConstants';

export interface TableWithMissingSchemaProps {
  selectable?: boolean;
}

/**
 * Component that represents a table that has a missing schema.
 */
const TableWithMissingSchema: React.FunctionComponent<BasicTableProps & TableWithMissingSchemaProps> = (
  props: BasicTableProps & TableWithMissingSchemaProps
): JSX.Element => {
  const {icon, indentation, tableTypeLabel, tableName} = props;
  return (
    <AlwaysCollapsedTable
      icon={icon}
      indentation={indentation}
      tableTypeLabel={tableTypeLabel}
      tableName={tableName}
      tooltipText="You do not have permission to view this table's schema"
      selectable={props.selectable}
    />
  );
};

export default TableWithMissingSchema;
